import React from "react";
import { CloseIcon } from "../../../icons";

const ApproveDraftModal = ({ show, onClose, onConfirm, isLoading, chargeAmount }) => {
    if (!show) return null;

    return (
        <div className="tw:fixed tw:inset-0 tw:z-[9999] tw:flex tw:items-center tw:justify-center">
            <div className="tw:absolute tw:inset-0 tw:bg-[#00000099]" onClick={() => !isLoading && onClose()} />
            <div className="tw:relative tw:z-[10000] tw:w-[calc(100%-24px)] tw:lg:w-[500px] tw:rounded-[8px] tw:bg-white tw:px-4 tw:py-5 tw:md:px-10 tw:md:py-8 tw:shadow-lg">
                <button type="button" onClick={onClose} disabled={isLoading} className="tw:absolute tw:top-6 tw:right-6">
                    <CloseIcon color="#7c7b7b" size={16} />
                </button>
                <div className="tw:text-center tw:mt-4 tw:mb-6">
                    <p className="tw:text-[#282828] tw:mb-0 tw:text-[18px] tw:font-[600] tw:font-hanken-grotesk">
                        {chargeAmount > 0
                            ? `Approve this draft and charge ¥${chargeAmount.toLocaleString()} JPY?`
                            : "Approve this draft and update the booking details?"}
                    </p>
                </div>
                <div className="tw:flex tw:flex-col tw:lg:flex-row tw:items-stretch tw:gap-2">
                    <button type="button" onClick={onClose} disabled={isLoading} className="tw:flex-1">
                        <div className="tw:py-3 tw:w-full tw:rounded-[8px] tw:border tw:border-[#d0d0d0] tw:bg-white tw:text-[#282828] tw:text-[15px] tw:leading-[22px] tw:font-medium tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center">
                            Cancel
                        </div>
                    </button>
                    <button type="button" onClick={onConfirm} disabled={isLoading} className="tw:flex-1">
                        <div className={`tw:py-3 tw:w-full tw:rounded-[8px] tw:text-white tw:text-[15px] tw:leading-[22px] tw:font-[700] tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center tw:gap-2 ${chargeAmount > 0 ? "tw:bg-[#3CAEA3]" : "tw:bg-[#DBBE78]"} ${isLoading ? "tw:opacity-70" : ""}`}>
                            {isLoading && (
                                <svg className="tw:animate-spin tw:h-4 tw:w-4 tw:text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="tw:opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                    <path className="tw:opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                                </svg>
                            )}
                            {isLoading ? "Processing…" : "Approve"}
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApproveDraftModal;
